<template lang="pug">
v-card.mb-3
  v-card-text
    template(v-if="!page")
      v-progress-linear(indeterminate v-if="$apollo.queries.fodynModelPages.loading")

    template(v-else-if="page.type === 'form'")
      v-form(ref="formPage" @submit.prevent="submitForm")
        v-layout(row wrap)
          v-flex(xs12)
            layout-tree(:value="{ children: groups }" :border="false")
              template(slot-scope="{ item, itemI, parent, depth }")
                template(v-for="field in item.fields")
                  extra-fodyn-field(:values="values" :field="field" :model="page.model" @buttonClick="btnClick" :status="status")

    template(v-else-if="page.type === 'index'")
      v-form(ref="formPage" @submit.prevent="submitForm")
        v-layout(row wrap)
          v-flex(xs12)
            layout-tree(:value="{ children: groups }" :border="false")
              template(slot-scope="{ item, itemI, parent, depth }")
                template(v-for="field in item.fields")
                  extra-fodyn-field(:values="values" :field="field" :fields="item.fields" :model="page.model" @buttonClick="btnClick" :status="status" :table-data="tableData")

</template>

<script>
import gql from 'graphql-tag'
import uuidv4 from 'uuid/v4'
import LayoutTree from '../layout-tree'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import ExtraFodynField from './extra-fodyn-field'
import moment from 'moment'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  components: {
    LayoutTree,
    ExtraFodynField,
  },
  data() {
    return {
      fodynModelPages: [],
      values: [],
      groups: [],
      tableData: [],
      status: {
        loading: false,
        success: false,
        error: false,
        errors: { '': [] },
      },
      loading: 0,
    }
  },
  apollo: {
    fodynModelPages: {
      query: gql`query ExtraFodynBuilderVueFodynModelPages($slug: String) {
        fodynModelPages(where: { slug: $slug }) {
          id
          name
          slug
          type
          model {
            id
            name
            table
            usePaperTrail
            columns {
              id
              name
              type
              nullable
              default
              deleted
            }
            validations {
              id
              name
              type
              regex
              min
              max
              values
            }
          }
          groups {
            id
            widths
            containerFlex
            parentId
            fields {
              id
              columnId
              type
              label
              labelHtml
              clearable
              hint
              persistentHint
              hideDetails
              color
              subtype
              validationIds
              columnIds
              conditions {
                action
                type
                columnId
                value
              }
            }
          }
        }
      }`,
      variables() {
        return {
          slug: this.extra.options.xid
        }
      },
      skip() {
        return !this.extra || !this.extra.options || !this.extra.options.xid
      }
    }
  },
  watch: {
    page(page) {
      if (page) {
        this.resetForm()

        let allGroups = page.groups.map((group) => ({ ...group, children: [] }))
        let roots = []
        allGroups.forEach((group) => {
          if (group.parentId) {
            let parent = allGroups.find((g) => g.id === group.parentId)
            if (parent) {
              parent.children.push(group)
            } else {
              console.error('orphaned group', group)
            }
          } else {
            roots.push(group)
          }
        })
        this.groups = roots
      }
    },
    loading(loading) {
      this.status.loading = loading > 0
    }
  },
  computed: {
    page() {
      const slug = this.extra && this.extra.options && this.extra.options.xid
      if (slug && this.fodynModelPages[0] && this.fodynModelPages[0].slug === slug) {
        return this.fodynModelPages[0]
      }
    },
    usedColumnIds() {
      const columnIds = {}
      if (this.page) {
        this.page.groups.forEach((group) => {
          group.fields.forEach((field) => {
            if (field.columnId) {
              columnIds[field.columnId] = true
            }
          })
        })
      }
      return columnIds
    },
    columnIds() {
      const columnIds = {}
      const used = this.usedColumnIds
      if (this.page) {
        this.page.model.columns.forEach((c) => {
          if (used[c.id]) {
            columnIds[c.name] = c.id
          }
        })
      }
      return columnIds
    },
  },
  methods: {
    btnClick(type) {
      if (type === 'reset') {
        this.resetForm()
      } else if (type === 'clearErrors') {
        this.clearErrors()
      } else if (type === 'submit') {
        this.submitForm()
      }
    },
    clearErrors() {
      this.status.success = false
      this.status.error = false
      this.status.errors = { '': [] }
    },
    resetForm() {
      const values = {}
      const used = this.usedColumnIds
      this.page.model.columns.forEach((c) => {
        if (used[c.id]) {
          if (c.default === 'now' && c.type === 'datetime') {
            values[c.id] = moment().toISOString()
          } else if (c.default === 'now' && c.type === 'date') {
            values[c.id] = moment().format('YYYY-MM-DD')
          } else {
            values[c.id] = c.default
          }
        }
      })
      this.values = values
      this.clearErrors()
    },
    submitForm() {
      this.gqlClearAllErrors()
      this.clearErrors()
      if (!this.$refs.formPage.validate()) {
        return
      }
      const values = this.values
      const data = []
      const columnIds = this.columnIds
      this.page.model.columns.forEach((c) => {
        if (columnIds[c.name]) {
          data.push({ name: c.name, value: values[c.id] })
        }
      })

      this.loading++
      this.$apollo.mutate({
        mutation: gql`mutation ExtraFodynPageSubmitForm (
            $page: String!
            $formData: [FodynModelPageInput!]!
        ) {
          fodynModelPageSubmit(
            page: $page
            formData: $formData
          ) {
            success
          }
        }`,
        variables: {
          page: this.page.slug,
          formData: data,
        }
      }).then((response) => {
        this.loading--
        if (response && response.data && response.data.fodynModelPageSubmit && response.data.fodynModelPageSubmit.success) {
          this.status.success = true
        } else {
          this.status.error = true
        }
      }, (error) => {
        this.loading--
        this.status.error = true
        this.gqlAddErrors(error)
        this.status.errors = this.errorsForColumns()
      })
    },
    errorsForColumns() {
      const ids = this.columnIds
      const errors = {}
      Object.entries(ids).forEach(([name, id]) => {
        errors[id] = this.gqlErrorsFor('fodynModelPageSubmit', name)
      })
      errors[''] = this.gqlErrorsFor('fodynModelPageSubmit')
      return errors
    }
  }
}
</script>
